// import { createSelector } from 'reselect';

export const getProduct = state => state.getIn(['product', 'product']);
export const getBuyQuantity = state => state.getIn(['product', 'buyQuantity']);

// export const getStores = state => state.getIn(['stores', 'stores']);
// export const getSelectedStoreId = state => state.getIn(['stores', 'selectedStoreId']);

// export const getSelectedStore = createSelector(
//   [getStores, getSelectedStoreId],
//   (stores, selectedStoreId) => stores.getIn([selectedStoreId])
// )